import Skeleton from '@mui/material/Skeleton';
import React from 'react';

export const SkeletonPagePDF = () => (
  <Skeleton height={600} variant="rect" width="100%" />
);
